/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "14987c711bb799e280c47b8e006596c1aa9698a1";
